<template>
  <div class="mt-5">
    <b-row style="justify-content: center">
      <b-col cols="10">
        <div class="text-left">
          <b>Review Results & Download Report</b>
          <p>Name Searched: <b>EthixBase</b></p>
          <p>Jurisdiction: <b>Afghanistan</b></p>
        </div>
        <b-card>
          <b-table head-variant="light" :fields="staticFields"></b-table>
        </b-card>
        <p class="text-left mt-3">
          Note: Your third party has an Instant Due Diligence PLUS (IDD+) Report
          risk alert. We have automatically sent an email notification to the
          ethiXbase support team to remediate this report for any possible false
          positive alerts. Please expect an IDD⁺ remediated report for your
          third party in the EB platform within 48 business hours.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ReviewResult",
  data() {
    return {
      staticFields: [
        { key: "subject_name", label: "Subject Name" },
        { key: "entity_type", label: "Entity Type" },
        { key: "Country", label: "Country" },
        { key: "report_result", label: "IDD⁺ Report Results" },
        { key: "DDL", label: "DDL" },
        { key: "download", label: "Download IDD⁺ Report" },
        { key: "edd", label: "Order EDD" },
      ],
    };
  },
};
</script>

<style>
</style>